<procure-card
  class="gauge-chart-widget"
  [class.transparent]="transparent()"
>
  @if (needlePosition() !== null && !isNan(needlePosition())) {
    <div class="gauge-wrapper">
      <procure-gauge-chart
        class="gauge-chart"
        [arcColors]="arcColors()"
        [arcDelimiters]="arcDelimiters()"
        [needlePosition]="needlePosition() || 0"
        [height]="height()"
      />
    </div>
  } @else {
    <h3 class="gauge-title">n/a</h3>
  }
  <div class="gauge-label">
    {{ label() }}
  </div>
</procure-card>
